import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Card, CardGroup, Col, Container, Row } from "react-bootstrap";
import { useAlert } from "../../../../context/AlertContext";
import { AddIcon } from "../../../../data/iconImage";
import { formatSplitKey } from "../../../../commons/FormatValue";
import { FloatingControlComponent } from "../../../../components/FormComponent";
import {
  deleteServiceRequest,
  getServiceRequest
} from "../../../../commons/ServiceRequest";
import {
  filteredItemByArray,
  filteredCreateNewKey,
  findItemInArray,
  filteredItemByFindArray
} from "../../../../utils/ManageArray";
import SearchFilter from "../../../../components/SearchFilter";
import ButtonLink from "../../../../components/ButtonLink";
import Table from "../../../../components/Table";
import ButtonOptionSubmenu from "../../../../components/ButtonOptionSubmenu";
import BarcodeGenerator from "../../../../components/BarcodeGenerator";
import ChildBomsService from "../../../../services/childboms.service";
import ItemStepDesService from "../../../../services/itemstepdes.service";
import ItemStepMastersService from "../../../../services/itemstepmas.service";
import ItemStdRecordsService from "../../../../services/itemstdrecord.service";
import ContractSpecDtsService from "../../../../services/contractspecdt.service";
import ContractSpecHdsService from "../../../../services/contractspechd.service";
import ItemStdCustomersService from "../../../../services/itemstdcustomer.service";

export default function ServiceRequest() {
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState(
    state || { StepDes: [], StdCus: [], SpecHd: [] }
  );
  const [data, setData] = useState({
    StepMas: [],
    StepDes: [],
    StdCus: [],
    WorkCheck: [],
    StdRecord: [],
    SpecHd: [],
    SpecDt: []
  });
  const columns = {
    StepDes: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "ขั้นตอนการปฏิบัติงาน",
        selector: (row) => row.Item_Step_Des,
        sortable: true,
        grow: 2
      },
      {
        name: "Priority",
        selector: (row) => row.Item_Step_Priority,
        center: true
      },
      {
        name: "เงื่อนไขการข้าม1",
        selector: (row) => (row.Item_Step_Require1 ? "Y" : "N"),
        center: true
      },
      {
        name: "เงื่อนไขการข้าม2",
        selector: (row) => (row.Item_Step_Require2 ? "Y" : "N"),
        center: true
      }
    ],
    StdCus: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "ขั้นตอนการปฏิบัติงานเพิ่มเติม",
        selector: (row) => row.Item_Std_Des,
        grow: 2
      },
      { name: "Priority", selector: (row) => row.Priority, center: true },
      {
        name: "เงื่อนไขการข้าม1",
        selector: (row) => (row.Item_Std_Skip1 ? "Y" : "N"),
        center: true
      },
      {
        name: "เงื่อนไขการข้าม2",
        selector: (row) => (row.Item_Std_Skip2 ? "Y" : "N"),
        center: true
      },
      {
        name: "",
        selector: (row) => (
          <ButtonOptionSubmenu
            data={row}
            editButton
            deleteButton
            state={{ edit: { type: "StdCus", searchValue } }}
            onDeleteCallback={(event, { Id }) =>
              handleSubmitDelete({ event, Id, type: "StdCus" })
            }
          />
        ),
        width: "180px",
        right: true
      }
    ],
    WorkCheck: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px"
      },
      { name: "รหัสสินค้า", selector: (row) => row.Item?.Item_Code },
      { name: "Model Number", selector: (row) => row.Item?.Item_Model },
      {
        name: "บาร์โคด",
        selector: (row) => (
          <BarcodeGenerator value={`${row.Item?.Item_Model || " "}`} />
        ),
        width: "200px"
      },
      { name: "สถานะ", selector: (row) => "เช็ค" }
    ],
    StdRecord: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "รายละเอียดการบันทึก",
        selector: (row) => row.Item_Record_Des,
        grow: 2
      },
      { name: "ค่า", selector: (row) => row.Record_Value, center: true },
      { name: "หน่วย", selector: (row) => row.Record_UOM },
      {
        name: "",
        selector: (row) => (
          <ButtonOptionSubmenu
            data={row}
            editButton
            deleteButton
            state={{ edit: { type: "Record", searchValue } }}
            onDeleteCallback={(event, { Id }) =>
              handleSubmitDelete({ event, Id, type: "StdRecord" })
            }
          />
        ),
        width: "180px",
        right: true
      }
    ],
    SpecDt: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "รายละเอียดขัอกำหนดเพิ่มเติมตามสัญญา",
        selector: (row) => row.Con_Spec_Des
      },
      { name: "ขัอกำหนดเพิ่มเติมอื่นๆ", selector: (row) => row.Remark },
      { name: "PM/ครั้งที่", selector: (row) => row.PM_Of_Work }
    ]
  };
  const searchInput = {
    StepDes: [
      { name: "Item.Item_Code", label: "รหัสสินค้า" },
      { name: "Item.Item_Name_TH", label: "ชื่อสินค้า" }
    ],
    StdCus: [
      { name: "Customer.Cus_Code", label: "รหัสลูกค้า (BP code)" },
      { name: "Customer.Cus_NumBranch", label: "รหัสสาขา" },
      { name: "Customer.Cus_Name", label: "ชื่อลูกค้า/สาขา" }
    ]
  };

  const AutoDisplayItemComponent = () => (
    <>
      {searchInput.StepDes.map(({ name, label }, index) => {
        const findData = findItemInArray(
          data.StepMas,
          "Id",
          searchValue.StepDes?.[0]?.value
        );
        const value = formatSplitKey(name, ".", findData);

        return (
          <Col key={index} sm={index === 1 ? 5 : 3} className="pt-3">
            <FloatingControlComponent
              disabled
              name={name}
              label={label}
              type="text"
              className="p-3"
              value={value}
            />
          </Col>
        );
      })}
    </>
  );

  const createCard = (title, body, align) => (
    <Card className="m-1 mb-4 p-4 border-0">
      {title && (
        <Card.Header className="p-3 border-bottom-0 bg-transparent">
          <Card.Title className={`mb-1 fs-2 text-${align}`}>
            {typeof title === "string" ? (
              title
            ) : (
              <ButtonLink
                linkTo="create"
                stateData={{
                  type: title?.type,
                  searchValue
                }}
                isDisabled={!searchValue.StepDes[0]?.value}
                buttonName="เพิ่มข้อมูล"
                buttonClass="py-2 px-3 rounded-pill"
                iconSrc={AddIcon}
                iconClass="me-2 mb-1"
                iconName="Add Icon"
              />
            )}
          </Card.Title>
        </Card.Header>
      )}
      <Card.Body>{body}</Card.Body>
    </Card>
  );

  const createCardGroup = (title, subTitle, body, style) => (
    <Card className="m-1 mb-4 p-4 border-0">
      <CardGroup className="p-3 flex-column">
        {title && (
          <Card.Header className="mb-3 p-0 bg-transparent">
            <Card.Title className="mb-1 pb-3 fs-2">{title}</Card.Title>
          </Card.Header>
        )}
        {subTitle}
        <Card.Body className="p-0" style={style?.body}>
          {body}
        </Card.Body>
      </CardGroup>
    </Card>
  );

  const serviceRequest = (serviceRequest, type) => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest,
      callback: (res) => setData((prev) => ({ ...prev, [type]: res }))
    });
  };

  const handleFilteredState = (dataFilter, inputSearch, newName) => {
    if (state) {
      return data?.[dataFilter]
        ?.filter((item) =>
          state?.[inputSearch]?.every(({ value }) =>
            value ? item.Id === value : item
          )
        )
        ?.map((item) => ({
          name: newName,
          value: item?.[newName.split(".")[0]]?.[newName.split(".")[1]]
        }));
    }
  };

  const handleSubmitDelete = ({ event, Id, type }) => {
    event.preventDefault();
    if (Id) {
      const serviceRequest =
        type === "StdCus"
          ? ItemStdCustomersService.deleteItemStdCustomers(Id, false)
          : ItemStdRecordsService.deleteItemStdRecords(Id, false);
      const refreshRequest =
        type === "StdCus"
          ? ItemStdCustomersService.getAllItemStdCustomers()
          : ItemStdRecordsService.getAllItemStdRecords();

      deleteServiceRequest({
        showAlert,
        setLoading,
        serviceRequest,
        refreshRequest,
        callback: (res) => setData((prev) => ({ ...prev, [type]: res }))
      });
    }
  };

  useEffect(() => {
    serviceRequest(ChildBomsService.getAllChildBoms(), "WorkCheck");
    serviceRequest(ContractSpecHdsService.getAllContractSpecHds(), "SpecHd");
    serviceRequest(ContractSpecDtsService.getAllContractSpecDts(), "SpecDt");
    serviceRequest(ItemStdRecordsService.getAllItemStdRecords(), "StdRecord");
    serviceRequest(ItemStepMastersService.getAllItemStepMasters(), "StepMas");
    serviceRequest(ItemStepDesService.getAllItemStepDescriptions(), "StepDes");
    serviceRequest(ItemStdCustomersService.getAllItemStdCustomers(), "StdCus");
  }, []);

  return (
    <>
      <Helmet>
        <title>คำสั่งหน้าใบสั่งงาน (Service request)</title>
        <meta name="description" content="Service Request Page" />
      </Helmet>

      <Container fluid className="p-3">
        {createCard(
          "ค้นหาสินค้า",
          <SearchFilter
            data={data.StepMas}
            inputField={searchInput.StepDes}
            searchValue={handleFilteredState(
              "StepMas",
              "StepDes",
              "Item.Item_Code"
            )}
            fieldClassName={{ actionButton: "w-auto py-2" }}
            searchCallback={(search) =>
              setSearchValue((prev) => ({
                ...prev,
                StepDes: search.some(({ value }) => value)
                  ? filteredCreateNewKey({
                      data: data.StepMas,
                      search,
                      newName: "Item_Step_Id",
                      newValue: "Id"
                    })
                  : []
              }))
            }
          />,
          "center"
        )}

        {createCard(
          "ขั้นตอนการทำงานมาตรฐาน",
          <Table
            data={data.StepDes}
            column={columns.StepDes}
            searchFilter={searchValue.StepDes}
            pending={loading}
          />,
          "start"
        )}

        {createCardGroup(
          "ขั้นตอนการทำงานเพิ่มเติมเฉพาะลูกค้า",
          <Card.Title className="mb-1 py-3 fs-2 text-center">
            ค้นหาลูกค้า
          </Card.Title>,
          <SearchFilter
            data={
              searchValue.StepDes?.some(({ value }) => value)
                ? filteredItemByArray(data.StdCus, searchValue.StepDes)
                : []
            }
            inputField={searchInput.StdCus}
            searchValue={state?.StdCus}
            fieldClassName={{ actionButton: "w-auto py-2" }}
            searchCallback={(search) =>
              setSearchValue((prev) => ({
                ...prev,
                StdCus: search.some(({ value }) => value) ? search : [],
                StepDes: search.some(({ value }) => value)
                  ? [
                      ...prev.StepDes,
                      filteredCreateNewKey({
                        data: data.StdCus,
                        search,
                        newName: "Cus_Id",
                        newValue: "Id"
                      })
                    ]
                  : [...prev.StepDes],
                SpecHd: search.some(({ value }) => value)
                  ? filteredCreateNewKey({
                      data: data.SpecHd,
                      search: filteredCreateNewKey({
                        data: data.StdCus,
                        search,
                        newName: "Cus_Id",
                        newValue: "Id"
                      }),
                      newName: "Con_Spec_Hd_Id",
                      newValue: "Id"
                    })
                  : []
              }))
            }
          />,
          { body: { maxHeight: "60px" } }
        )}

        {createCard(
          { type: "StdCus" },
          <Table
            data={filteredItemByArray(data.StdCus, searchValue.StepDes)}
            column={columns.StdCus}
            searchFilter={searchValue.StdCus}
            pending={loading}
          />,
          "end"
        )}

        {createCardGroup(
          "คำสั่ง ตรวจสอบ / เปลี่ยน sparepart",
          "",
          <Row className="justify-content-center">
            <AutoDisplayItemComponent />
          </Row>
        )}

        {createCard(
          "",
          <Table
            data={filteredItemByFindArray(
              { data: data.WorkCheck, key: "Parent_Bom_Id" },
              {
                data: data.StepMas,
                key: "Id",
                value: searchValue.StepDes?.[0]?.value
              }
            ).filter(({ Bom_Pm }) => Bom_Pm)}
            column={columns.WorkCheck}
            pending={loading}
          />
        )}

        {createCardGroup(
          "คำสั่งการบันทึกข้อมูล",
          "",
          <Row className="justify-content-center">
            <AutoDisplayItemComponent />
          </Row>
        )}

        {createCard(
          { type: "Record" },
          <Table
            data={data.StdRecord}
            column={columns.StdRecord}
            searchFilter={searchValue.StepDes}
            pending={loading}
          />,
          "end"
        )}

        {createCardGroup(
          "ข้อกำหนดเพิ่มเติม (คำสั่งพิเศษ)",
          "",
          <Table
            data={data.SpecDt}
            column={columns.SpecDt}
            searchFilter={searchValue.SpecHd}
            pending={loading}
          />
        )}
      </Container>
    </>
  );
}
